import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as i18next from 'i18next';
import * as flights from 'core/flights';
import moment from 'moment';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightCardComponent extends Vue {
    @Prop()
    flight: flights.FlightModel;

    @Prop()
    flightIndex: number;

    @Prop()
    filterFlight: flights.FlightFilterModel;

    @Prop()
    cheapestFlightId: string;

    @Prop()
    fasterFlightId:  string;

    @Prop()
    bestFlightId:  string;

    flightUniqueAirlinesLength: number;

    getLegDurationTime(leg: flights.LegModel){
        let result = '';

        if(leg.duration.asHours() < 1){
            result += Math.round(leg.duration.asMinutes()) + ' ' + i18next.t('label_minutes_short');
        } else {
            result += Math.round(leg.duration.asHours()) + i18next.t('label_tabs_hours');
        }

        return result.replace('.', ',');
    }

    getSegmentDurationTime(segment: flights.SegmentModel){
        let result = '';

        if (segment.connection.duration.asHours() < 1) {
            result += Math.round(segment.connection.duration.asMinutes()) + ' ' + i18next.t('label_minutes_short');
        } else {
            result += Math.round(segment.connection.duration.asHours() * 2) / 2 + i18next.t('label_tabs_hours');
        }

        return result.replace('.', ',');
    }

    getSegmentLabel(leg: flights.LegModel, segment: flights.SegmentModel, segmentIndex: number): string {
        let result = '';

        if (segment.arrivalDestination.iataCode === leg.segments[segmentIndex + 1].departureDestination.iataCode) {
            result += segment.arrivalDestination.iataCode;
        } else {
            result += segment.arrivalDestination.city.iataCode;
        }

        if (leg.segments.length > 1 && segmentIndex < (leg.segments.length - 2)) {
            result += ', ';
        }

        return result;
    }

    selectFlight() {
        this.$emit('select', this.filterFlight);
    }

    legsHasDifferentAirlines() {
        return this.flight.legs[0].segments[0].airline.iataCode !== this.flight.legs[1].segments[0].airline.iataCode;
    }

    getLegsSegmentsAirlinesDistinct() {
        const result: api.Airline[] = [];
        const map: string[] = [];
        const segments: flights.SegmentModel[] = [];

        this.flight.legs.forEach((leg) => {
            leg.segments.forEach((segment) => {
                segments.push(segment);
            });
        });

        for (const segment of segments) {
            if (!map.includes(segment.airline.uniqueId)) {
                map.push(segment.airline.uniqueId);
                result.push(segment.airline);
            }
        }

        this.flightUniqueAirlinesLength = result.length;
        return result;
    }
}
